<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class="flex">
        <el-select
          v-if="theUserProject == 0"
          v-model="theProjectId"
          @change="theProjectAllChange"
          size="small"
          clearable
          placeholder="请选择项目"
        >
          <el-option
            v-for="item in getProjectList_data.data || []"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="mtmId"
          clearable
          placeholder="请输入分类"
          size="small"
          style="max-width:150px;"
          @change="getData"
        >
          <el-option
            v-for="(item, index) in getMicrolectureTypeMainList_data || []"
            :key="index"
            :label="item.mtmName"
            :value="item.mtmId"
          ></el-option>
        </el-select>
        <el-select
          v-model="ymtmStatus"
          clearable
          placeholder="请输入状态"
          size="small"
          style="max-width:150px;"
          @change="getData"
        >
          <el-option label="进行中" :value="1"></el-option>
          <el-option label="已结束" :value="2"></el-option>
          <el-option label="已中断" :value="3"></el-option>
        </el-select>
        <el-select
          v-model="examType"
          clearable
          placeholder="请选择选项"
          size="small"
          style="max-width:150px;"
          @change="getData"
        >
          <el-option label="全部" :value="1"></el-option>
          <el-option label="第一次考试" :value="2"></el-option>
        </el-select>
        <el-input
          v-model="getMicrolectureTrainMainList_data.microlectureTitle"
          placeholder="请输入微课名"
          clearable
          size="small"
          style="max-width:200px;"
        />
        <el-input
          v-model="getMicrolectureTrainMainList_data.userName"
          placeholder="请输入用户名"
          clearable
          size="small"
          style="max-width:200px;"
        />
        <el-date-picker
          v-model="valueDate"
          size="small"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="timeChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="right"
        >
        </el-date-picker>
        <el-button
          v-click.getMicrolectureTrainMainList
          type="primary"
          icon="el-icon-search"
          size="small"
          style="margin-left:10px;"
          >搜索</el-button
        >
        <el-button
          @click="Bulksure()"
          type="success"
          icon="el-icon-search"
          size="small"
          style="margin-left:10px;"
          >导出
        </el-button>
      </el-col>
      <el-col :span="6"> </el-col>
    </el-row>

    <mytable
      :tableColums="tableColums_getMicrolectureTrainMainList"
      api="getMicrolectureTrainMainList"
      updateapi="updateMicrolectureTypeMain"
      :height="H - 165"
    >
    </mytable>
    <el-dialog
      title="详情"
      :visible.sync="viedoDet"
      width="88%"
      :before-close="DeailClose"
    >
      <div style="width: 100%;height: 300px;">
        <div
          ref="eCharts1"
          style="width: 80%;height: 100%; margin: 20px auto;"
        ></div>
      </div>
      <div
        v-if="detailArr.ymtmFaceEmotionDes"
        style="margin: 20px auto;color: red;font-size: 20px;width: 90%;text-align: center;"
      >
        {{ detailArr.ymtmFaceEmotionDes }}
      </div>
      <el-table
        v-if="detailArr.microlectureTrainList"
        :data="detailArr.microlectureTrainList || []"
        border
        highlight-current-row
        :header-cell-style="{
          textAlign: 'center',
          background: 'rgba(0,170,255,0.5)',
          color: 'black',
          border: 'none'
        }"
        style="width: 100%;margin:12px 0 0 0;"
      >
        <el-table-column type="index" width="50" label="序号" fixed="left">
        </el-table-column>
        <el-table-column prop="ymwCode" label="编号" width="100">
        </el-table-column>
        <el-table-column prop="ympQuestion" label="问题" width="200">
        </el-table-column>
        <el-table-column prop="ympContent" label="答案" width="360">
        </el-table-column>
        <el-table-column prop="ymtAudioWord" label="回答内容" width="300">
        </el-table-column>
        <el-table-column prop="ymtMatchWord" label="话术匹配度" width="90">
        </el-table-column>
        <el-table-column prop="ymtMatchKetword" label="关键词匹配度">
        </el-table-column>
        <el-table-column prop="ymtMatchComplete" label="完整性">
        </el-table-column>
        <el-table-column prop="ymtMatchTone" label="话语连贯性">
        </el-table-column>
        <el-table-column prop="ymtSensitiveNum" label="敏感词">
        </el-table-column>
        <el-table-column prop="ymtStatus" label="语音状态">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.ymtStatus == 1
                  ? 'warning'
                  : scope.row.ymtStatus == 2
                  ? 'info'
                  : scope.row.ymtStatus == 3
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.ymtStatus == 1
                  ? "未处理"
                  : scope.row.ymtStatus == 2
                  ? "已请求分析"
                  : scope.row.ymtStatus == 3
                  ? "分析完成"
                  : "分析失败"
              }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="ymtErrorMsg" label="请求分析失败原因">
        </el-table-column>
        <el-table-column prop="ymtFaceConfidence" label="视频分析自信度">
        </el-table-column>
        <el-table-column prop="ymtFaceEmotion" label="视频分析表情">
        </el-table-column>
        <el-table-column prop="ymtFaceStatus" label="视频分析状态" width="80">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.ymtFaceStatus == 1 ? 'warning' : 'success'"
            >
              {{ scope.row.ymtFaceStatus == 1 ? "未处理" : "已处理" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="ymtStatusTip" label="提示" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.ymtStatusTip == 1 ? 'warning' : 'success'">
              {{ scope.row.ymtStatusTip == 1 ? "未查看" : "已查看" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="180">
        </el-table-column>
        <el-table-column
          prop="ympVideo"
          label="回答视频"
          width="80"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="scope.row.ymtType == 2"
              @click="Preview(scope.row.ymtVideoPath)"
              >预览
            </el-button>
            <el-button
              size="mini"
              type="text"
              v-if="scope.row.ymtType == 1"
              @click="audioClick(scope.row)"
              >播放
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div
      style="width:90%;position:fixed;bottom: 5px;left: 10%;background-color: white;
             box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);z-index: 9999;"
      v-if="audioShow"
    >
      <i
        class="el-icon-close"
        style="margin-left: 95%;"
        @click="audioShow = false"
      ></i>
      <aplayer
        :music="audio2[0]"
        fixed
        v-if="audio2.length > 0"
        autoplay
        @ended="onEnded"
      />
    </div>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import aplayer from "vue-aplayer";
import echarts from "echarts";
export default {
  components: {
    aplayer
  },
  data() {
    return {
      examType: "",
      valueDate: "",
      ymtmTimeSubmitStart: "",
      ymtmTimeSubmitEnd: "",
      dtId: "",
      baseUrl: $Api.baseUrl_online,
      audio2: [],
      audioShow: false,
      audio: null,
      color: [
        " #4992ff",
        " #dd79ff",
        " #fddd60",
        "  #ff6e76",
        " #58d9f9",
        " #05c091",
        "  #ff8a45",
        " #8d48e3"
      ],
      echartsStr: "",
      echartsStrValue: [],
      ymtmStatus: "",
      microlectureTitle: "",
      getMicrolectureTypeMainList_data: [],
      theUserProject: "",
      theProjectId: "",
      detailArr: [],
      viedoDet: false,
      mtmId: null,

      tableColums_getMicrolectureTrainMainList: {
        $selection: false,

        microlectureTitle: "微课标题",
        mtmName: ["大分类", 140],
        mtName: ["类型", 140],
        dtName: ["战队", 120],

        userName: ["学员", 100],

        ymtmScore: ["得分", 80],

        microlectureScorePass: ["通过分数", 90],

        ymtmScoreStatus: [
          "得分状态",
          90,
          "@v-if: 2:未通过 #danger,  3:未处理 #warn,1:通过 #success"
        ],

        ymtmStatus: [
          "状态",
          80,
          "@v-if: 2:已结束 #(--Themecolor),  3:已中断 #warn,1:进行中 #danger"
        ],
        // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
        ymtmTimeSubmit: ["提交时间", 150],
        ymtmTimeComplete: ["分析完成时间", 150],
        createtime: ["创建时间", 150],
        $operation: [
          "操作",
          100,
          `@text: 详情#success @click: handelDetail($row)`
        ]
      }
    };
  },

  watch: {},

  methods: {
    theDtChange(e) {
      this.dtId = e;
      this.$refs.cascader.dropDownVisible = false;
      this.getData();
    },
    timeChange(e) {
      if (e) {
        this.ymtmTimeSubmitStart = e[0];
        this.ymtmTimeSubmitEnd = e[1];
      } else {
        this.ymtmTimeSubmitStart = "";
        this.ymtmTimeSubmitEnd = "";
      }
      this.getData();
    },
    audioClick(row) {
      this.audio2 = [];
      const s = {
        title: "录音",
        artist: "",
        src: row.ymtAudioPath,
        pic: 'https://eos-shanghai-2.cmecloud.cn/aojv/interview/682c50e8278747d280437f3a438b990e.png', // prettier-ignore
        lrc: ""
      };
      this.audio2.push(s);
      this.audioShow = true;
    },
    onEnded() {
      this.audio2 = [];
      this.audioShow = false;
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    Bulksure() {
      const bulkdata = {
        projectId: this.theProjectId,
        mtmId: this.mtmId,
        microlectureTitle: this.microlectureTitle,
        ymtmStatus: this.ymtmStatus,
        dtId: this.dtId,
        ymtmTimeSubmitStart: this.ymtmTimeSubmitStart,
        ymtmTimeSubmitEnd: this.ymtmTimeSubmitEnd,
        examType: this.examType
      };
      this.openLoading();
      var s = qs.stringify(bulkdata);
      var that = this;
      axios({
        method: "post",
        url:
          that.baseUrl +
          "/opportunity/microlecture-train-main/exportMicrolectureTrainMainList",
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: "arraybuffer",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          token: A.local("$Usertoken"),
          projectId: +A.local("$projectId")
        }
      }).then(function(res) {
        if (res.data) {
          that.loading.close();
          let a = document.createElement("a");
          //ArrayBuffer 转为 Blob
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "训练记录.xlsx");
          a.click();
          that.$message({
            message: "成功",
            type: "success"
          });
        }
      });
    },
    play(row) {
      if (this.audio != null && !this.audio.paused) {
        this.audio.pause();
      }
      if (this.audio == null) {
        this.audio = new Audio();
      }
      this.audio.src = row;
      this.audio.play();
    },
    Preview(url) {
      document.PreviewVideo(url);
    },
    // 图标配置项
    DrawEcharts() {
      console.log(this.$refs.eCharts1);
      this.echartsStr = this.$echarts.init(this.$refs.eCharts1);
      this.echartsStr.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        // backgroundColor: '#100C2A',
        title: {
          text: "训练分析",
          left: "3%",
          top: "3%"
        }, //标题位置

        tooltip: {
          trigger: "item"
        }, //提示框组件 ---数据项图形触发
        legend: {
          // orient: 'vertical', //图标列表的布局朝向
          right: "3%",
          top: "3%",
          data: ["训练分析"]
        },
        radar: {
          // shape: 'circle',
          indicator: this.echartsStrValue.data
        },
        series: [
          {
            type: "radar",
            radius: "80%",
            data: [
              {
                value: this.echartsStrValue.xdata,
                name: "训练分析"
              }
            ],

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },

    handelDetail(row) {
      this.echartsStrValue = {
        xdata: [],
        data: []
      };
      var maxNum = "";
      this.getMicrolectureTrainMainDetails({ ymtmId: row.ymtmId }).result(
        res => {
          console.log(res);
          if (res.data.data) {
            if (res.data.data.microlectureTrainRuleScoreItemList) {
              res.data.data.microlectureTrainRuleScoreItemList.forEach(
                (item, index) => {
                  this.echartsStrValue.xdata.push(item.mtrsiScore);
                  this.echartsStrValue.data.push({
                    name: item.mtrsiName,
                    max: ""
                  });
                }
              );
              maxNum = Math.max(...this.echartsStrValue.xdata);
              this.echartsStrValue.data.forEach(item => {
                item.max = maxNum;
              });
            }
            this.detailArr = res.data.data;
            this.$nextTick(() => {
              this.DrawEcharts();
            });

            this.viedoDet = true;
          }
        }
      );
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getData();
    },
    getData() {
      this.getMicrolectureTrainMainList({
        projectId: this.theProjectId,
        mtmId: this.mtmId,
        microlectureTitle: this.microlectureTitle,
        ymtmStatus: this.ymtmStatus,
        dtId: this.dtId,
        ymtmTimeSubmitStart: this.ymtmTimeSubmitStart,
        ymtmTimeSubmitEnd: this.ymtmTimeSubmitEnd,
        examType: this.examType,
        currentPage: 1
      });
    }
  },

  async created() {
    this.getMicrolectureTypeMainLists().result(res => {
      if (res.data.data) {
        console.log(res.data.data);
        this.getMicrolectureTypeMainList_data = res.data.data;
      }
    });
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getMicrolectureTrainMainList({ projectId: A.local("$projectId") });
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/bussiness/trainRecord.vue